import { Injectable } from '@angular/core';
import { BorrowerDTO } from '../../../models/borrower/borrower-dto';
import { DLPRestUtilityService } from '../../rest/dlprest-utility.service';
import { HttpErrorResponse } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class PrimaryFormPopulateService {

  dataFetched: BorrowerDTO[];
  coApplicantBorrower: BorrowerDTO;

  constructor(private dLPRestUtilityService: DLPRestUtilityService)
    { }


  //for fetching the data of personal form
  // fetchPrimaryBorrowerDetails() {
  //  // this.dLPRestUtilityService.getPrimaryBorrower().subscribe(res => {
  //     let data = res;
  //       this.dataFetched = data;
  //       this.spinner.hide();
  //       this.afterDataFetched();

  //   },
  //     (err: HttpErrorResponse) => {
  //       if (err.error instanceof Error) {
  //         //A client-side or network error occurred.				 
  //         console.log('An error occurred:', err.error.message);
  //       } else {
  //         //Backend returns unsuccessful response codes such as 404, 500 etc.				 
  //         console.log('Backend returned status code: ', err.status);
  //         console.log('Response body:', err.error);
  //       }
  //     }
  //   )
  // }

  //for checking which on is the primary borrower based on primary cust flag
  afterDataFetched() {
  let findingPrimaryCustFlagArray = Object.keys(this.dataFetched)
  findingPrimaryCustFlagArray.forEach(x => {
    if (this.dataFetched[x].primaryCustFlag) {
      //this.primaryBorrower = new BorrowerDTO();
      //this.primaryBorrower = this.nullRemover(this.dataFetched[x]);
    }
    else if (!this.dataFetched[x].primaryCustFlag) {
      this.coApplicantBorrower = new BorrowerDTO();
      this.coApplicantBorrower = this.nullRemover(this.dataFetched[x]);
    }
  }
  )
}


// removing null and undefined values from the get json so that only valid values are displayed
nullRemover(borrower: BorrowerDTO) {
  let cleanBorrower: BorrowerDTO; // borrower without null values
  cleanBorrower = borrower;
  let primaryCustArray = Object.keys(borrower);
  primaryCustArray.forEach(x => {
    if (borrower[x] != null || borrower[x] == undefined) {
      cleanBorrower[x] = borrower[x];
    }
  })
  return cleanBorrower;
}

}

